import { useEffect } from "react"
import { useDangerCategoryObserver } from "@app/components/ExtendedPropertyList/DangerCategoryObserver.jsx"
import { useDangerFieldsObserver } from "@app/components/ExtendedPropertyList/DangerFieldsObserver.jsx"
import { useBodyPartsObserver } from "@app/components/ExtendedPropertyList/BodyPartsObserver.jsx"
import useBodyPartsActionsObserver from "@app/components/ExtendedPropertyList/BodyPartsActionsObserver.jsx"
import useFactsheetObserver from "@app/components/ExtendedPropertyList/FactsheetObserver.jsx"
import { usePhysicalDangerObserver } from "@app/components/ExtendedPropertyList/PhysicalDangerObserver.jsx"
import { useDangerMeasureObserver } from "@app/components/ExtendedPropertyList/DangerMeasureObserver.jsx"

const MainObserver = ({ currentFieldsets, setCurrentFieldsets, ...otherProps }) => {
	let res
	res = useDangerCategoryObserver(currentFieldsets, otherProps)
	res = useDangerFieldsObserver(res.fieldsets)
	res = useBodyPartsObserver(res.fieldsets)
	res = useBodyPartsActionsObserver(res.fieldsets, otherProps)
	res = useFactsheetObserver(res.fieldsets, otherProps)
	res = usePhysicalDangerObserver(res.fieldsets, otherProps)
	res = useDangerMeasureObserver(res.fieldsets, otherProps)

	useEffect(() => {
		if (res.fieldsets !== currentFieldsets && JSON.stringify(res.fieldsets) !== JSON.stringify(currentFieldsets)) {
			setCurrentFieldsets(res.fieldsets)
		}
	}, [res.fieldsets])

	return null
}

export default MainObserver